import getApiClient from "../../../shared/api";
import {
  showInfo,
  showError,
  clearNotifications
} from "../../../notifications/ducks/actions";

export const SEND_DICOUNTS_TO_USERS = "SEND_DICOUNTS_TO_USERS";

export function fetchUsers() {
  return (dispatch) => {
    dispatch({
      type: "FETCH_USERS",
      payload: getApiClient().get(`/admin/users`)
    });
  };
}

export function sendDiscountsToUsers() {
  return (dispatch) => {
    dispatch({
      type: SEND_DICOUNTS_TO_USERS,
      payload: getApiClient().put(`/admin/users/SendDiscounts`, {}),
    }).then((response) => {
      dispatch(showInfo(`Successfully sent discounts`));
    })
      .catch((response) => {
        dispatch(showError(`Error sending discounts`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}
